export function bookingPhoneDigits(value) {
  const raw = typeof value === "string" ? value : "";
  let digits = raw.replace(/\D/g, "");
  if (/\+1/.test(raw.replace(/\s/g, "")) && digits.startsWith("1")) digits = digits.slice(1);
  return digits.slice(0, 10);
}

export function normalizePhoneNumber(value) {
  return bookingPhoneDigits(value);
}

export function formatPhoneNumber(value) {
  const local = bookingPhoneDigits(value);
  return [local.slice(0, 3), local.slice(3, 6), local.slice(6)].filter(Boolean).join("-");
}

export function isValidPhoneNumber(value) {
  return bookingPhoneDigits(value).length === 10;
}

export function parseBookingPhone(phone, extension) {
  const text = typeof phone === "string" ? phone.trim() : "";
  const match = text.match(/\s*(?:ext\.?|x)\s*(\d+)\s*$/i);
  return {
    phone: bookingPhoneDigits(match ? text.slice(0, match.index) : text),
    ext: String(extension || match?.[1] || "").replace(/\D/g, ""),
  };
}
